// extracted by mini-css-extract-plugin
export var cartContainer = "_po-4";
export var gray = "_po-1";
export var itemContainer = "_po-2";
export var itemDetails = "_po-3";
export var strong = "_po-0";